import './EditionPage.scss';
import { SimpleNumberCard } from '@design-system/index';
import { SuiviBilleterieLine } from '@icons';
import { MutationTable } from '@components/Table/MutationTable/MutationTable';
import { ColumnDef } from '@tanstack/react-table';
import { formatDate } from '@utils/dates';
import { useTicketingEditionPageVM } from './useEditionPageVM';
import { TicketingTable } from '@services/member/ticketing/ticketing.types';
import { TicketType } from '@services/member/list/ticket-types/ticket-types.types';
import { useGetTicketingEditionMutation, useGetTicketingEditionExportMutation } from '@services/member/ticketing/ticketing.endpoints';
import { formatMoney } from '@utils/numbers';
export default function TicketingEditionPage() {
    const {
        handleMetadata,
        columnHelper,
        ticketTypes,
        totalMembers
    } = useTicketingEditionPageVM();

    const columns = [
        columnHelper.accessor((row) => row.member?.fullname ?? '', {
            header: 'Adhérent',
            id: 'member.personalInformation.lastname',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.ticketType.label, {
            id: 'ticketType.label',
            header: 'Type de billet',
            meta: {
                clickable: true
            },
            enableSorting: true,
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.ticketingAt, {
            id: 'ticketingAt',
            header: 'Date de vente',
            meta: {
                clickable: true
            },
            enableSorting: true,
            cell: (info) => <>{formatDate(info.getValue())}</>
        }),
        columnHelper.accessor((row) => row.saleCount, {
            id: 'saleCount',
            header: 'Nombre de billets',
            meta: {
                clickable: true
            },
            enableSorting: false,
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.saleAmount, {
            id: 'saleAmount',
            header: 'Montant total',
            meta: {
                clickable: true
            },
            enableSorting: false,
            cell: (info) => <>{formatMoney(info.getValue())}</>
        }),
        columnHelper.accessor(
            (row) => (
                <>
                    <div>{row.firstTicketNumber}</div>
                    <div>{row.lastTicketNumber}</div>
                </>
            ),
            {
                id: 'firstTicketNumber',
                header: 'Numéros des billets',
                meta: {
                    clickable: true
                },
                enableSorting: true,
                cell: (info) => <>{info.getValue()}</>
            }
        ),
        columnHelper.accessor((row) => row.isArchived, {
            id: 'isArchived',
            header: 'Archivé',
            meta: {
                clickable: true
            },
            enableSorting: true,
            cell: (info) => <>{info.getValue() ? 'Oui' : 'Non'}</>
        })
    ] as ColumnDef<TicketingTable>[];

    return (
        <div className="members-table-container">
            <div className="members-table-container-header">
                <div className="members-table-container-header-left">
                    <SimpleNumberCard
                        labelForSingle={'Vente'}
                        labelForMultiple={'Ventes'}
                        value={totalMembers}
                    />
                </div>
            </div>
            <MutationTable
                key={'edition'}
                columns={columns}
                selectable={false}
                mutationHook={useGetTicketingEditionMutation}
                defaultSorting={{
                    field: 'ticketingAt',
                    direction: 'desc'
                }}
                exportable={true}
                exportMutationHook={useGetTicketingEditionExportMutation}
                headerTitle={'Édition billetterie'}
                headerIcon={<SuiviBilleterieLine />}
                headerIconColor="green-water"
                onMetadata={handleMetadata}
                filters={[
                    {
                        id: 'ticketingAt',
                        label: 'Date de vente',
                        type: 'date',
                        comparatorTypes: ['isBetween', 'isBefore', 'isAfter', 'equals']
                    },
                    {
                        id: 'ticketType',
                        label: 'Type de billet',
                        type: 'select',
                        options: ticketTypes.map((ticketType: TicketType) => ({ label: ticketType.label, value: ticketType.id.toString() }))
                    },
                    {
                        id: 'isArchived',
                        label: 'Archivé',
                        type: 'boolean'
                    }
                ]}
            />
        </div>
    );
}
